import { API_ROOT } from '#src/config.ts';

import { load } from './http.ts';

export const getSalt = async (email: string) => {
  const { salt } = await load<{ salt: string }>(
    `${API_ROOT}/api/v1/users/${email}`,
    true
  );
  return salt;
};
